import { Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

export default function WhyFree() {
  const { t } = useLang();
  const d = t.owner.whyFree;
  return (
    <section className="bg-paper py-20 md:py-28 border-t border-line" data-testid="why-free">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <Overline>{d.overline}</Overline>
          <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl md:text-5xl tracking-tight max-w-3xl leading-[1.08]">
            {d.title}
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {d.cards.map((c, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className={`h-full rounded-2xl p-8 flex flex-col ${i === 2 ? "bg-ink text-white" : "bg-mist border border-line"}`}>
                <div className={`h-11 w-11 rounded-xl flex items-center justify-center ${i === 2 ? "bg-brand text-white" : "bg-moss/15 text-moss"}`}>
                  {i === 2 ? <span className="font-serif font-semibold text-lg">?</span> : <Check size={22} strokeWidth={2.5} />}
                </div>
                <h3 className={`mt-5 text-lg font-semibold tracking-tight ${i === 2 ? "text-white" : ""}`}>{c.t}</h3>
                <p className={`mt-2 leading-relaxed text-sm ${i === 2 ? "text-white/70" : "text-stone"}`}>{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
